<template>
  <section class="py-12 bg-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div v-if="loading" class="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        <div v-for="i in 4" :key="i" class="p-6 rounded-lg bg-light">
          <div class="text-3xl md:text-4xl font-bold text-gray-300 mb-2">--</div>
          <div class="text-gray-400">加载中...</div>
        </div>
      </div>
      
      <div v-else class="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        <div class="p-6 rounded-lg bg-light">
          <div class="text-3xl md:text-4xl font-bold text-primary mb-2">{{ stats.totalCourses || '500+' }}</div>
          <div class="text-gray-dark">精品课程</div>
        </div>
        <div class="p-6 rounded-lg bg-light">
          <div class="text-3xl md:text-4xl font-bold text-primary mb-2">{{ stats.totalJobs || '200+' }}</div>
          <div class="text-gray-dark">合作企业</div>
        </div>
        <div class="p-6 rounded-lg bg-light">
          <div class="text-3xl md:text-4xl font-bold text-primary mb-2">{{ stats.totalUsers || '10万+' }}</div>
          <div class="text-gray-dark">注册用户</div>
        </div>
        <div class="p-6 rounded-lg bg-light">
          <div class="text-3xl md:text-4xl font-bold text-primary mb-2">{{ stats.employmentRate || '98%' }}</div>
          <div class="text-gray-dark">就业率</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { statsAPI } from '@/api/services'

export default {
  name: 'StatsSection',
  data() {
    return {
      stats: {},
      loading: true
    }
  },
  async mounted() {
    await this.loadStats()
  },
  methods: {
    async loadStats() {
      try {
        const response = await statsAPI.getStats()
        this.stats = response
      } catch (error) {
        console.error('加载统计数据失败:', error)
        this.stats = {}
      } finally {
        this.loading = false
      }
    }
  }
}
</script> 